module.exports = __webpack_public_path__ + "assets/img/1.6c7ce16a.png";